import axiosAPI from '@/api/axios'

export default {
  async fetchAll() {
    return await axiosAPI.get('/api/partner-consents')
  },

  async fetchOne(partnerName) {
    return await axiosAPI.get(
      `/api/partner-consents/${encodeURIComponent(partnerName)}`,
    )
  },

  async update(partnerName, payload) {
    return await axiosAPI.post(
      `/api/partner-consents/${encodeURIComponent(partnerName)}`,
      payload,
    )
  },

  async sync() {
    return await axiosAPI.post('/api/partner-consents/sync')
  },

  async exportConsents(partnerName) {
    return await axiosAPI.get(
      `/api/partner-consents/${encodeURIComponent(partnerName)}/export`,
    )
  },

  async importConsents(partnerName, payload) {
    return await axiosAPI.post(
      `/api/partner-consents/${encodeURIComponent(partnerName)}/import`,
      payload,
    )
  },
}
